$(document).ready(function() {
  var Accordion = function (el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    var links = this.el.find(".footer-link");
    links.on("click", { el: this.el, multiple: this.multiple }, this.dropdown);
  };

  Accordion.prototype.dropdown = function (e) {
    var $el = e.data.el;
    var $this = $(this),
      $next = $this.next();
    var $openIcon = $this.find("#footer-open-icon");
    var $closeIcon = $this.find("#footer-close-icon");

    $next.slideToggle();
    $this.parent().toggleClass("footer-open");

    if ($this.parent().hasClass("footer-open")) {
      $openIcon.hide();
      $closeIcon.show();
    } else {
      $openIcon.show();
      $closeIcon.hide();
    }

    if (!e.data.multiple) {
      $el
        .find(".footer-submenu-mob")
        .not($next)
        .slideUp()
        .parent()
        .removeClass("footer-open")
        .find("#footer-open-icon")
        .show()
        .end()
        .find("#footer-close-icon")
        .hide();
    }
  };

  var accordion = new Accordion($("#footer-accordion"), false);
});